import { Link } from "@tanstack/react-router";
import { useHeaderContext } from "./HeaderContext";
import { Breadcrumb } from "@/components/ui/Breadcrumb";

/**
 * GlobalHeader - Top navigation bar with logo, breadcrumbs, and context actions.
 * - Left: TinyClub logo (links to home) + Breadcrumb navigation
 * - Right: Screen-specific action buttons (from HeaderContext)
 */
export function GlobalHeader() {
  const { config } = useHeaderContext();

  return (
    <header className="pt-3 pb-3 pl-4 pr-6 flex items-center justify-between bg-background">
      {/* Left: Logo + Breadcrumbs */}
      <div className="flex items-center gap-4">
        <Link to="/" className="flex items-center">
          <img
            src="/images/logomark.png"
            alt="TinyClub"
            className="w-12 h-12 object-contain"
          />
        </Link>

        {/* Breadcrumbs */}
        {config.breadcrumbs.length > 0 && (
          <Breadcrumb items={config.breadcrumbs} />
        )}
      </div>

      {/* Right: Screen-specific actions */}
      {config.actions && (
        <div className="flex items-center gap-2">
          {config.actions}
        </div>
      )}
    </header>
  );
}
